import { useEffect, useContext } from 'react';
import { CalculatorsContext, DraftContext } from '../context';
import { updateCalcAnswer } from '../api/rest/list';
import { CALC_MODELS } from '../constants';
import { useLocation } from 'react-router-dom';

export const useAnswersSyncByModel = () => {
  const { pathname } = useLocation();
  const { answers, dirtyAnswersMap, setDirtyAnswersMap, chartData } =
    useContext(CalculatorsContext);
  const { draftId } = useContext(DraftContext);

  const getCo2FilledAnswers = () => {
    const customCo2Answers = answers[CALC_MODELS.CUSTOM_CO2];
    if (!customCo2Answers) return null;

    const co2answers = customCo2Answers.answers || {};

    const filteredAnswers = Object.keys(co2answers).reduce((acc, key) => {
      const scopeAnswers = co2answers[key]?.filter((activity) => activity.filled);
      return scopeAnswers?.length ? { ...acc, [key]: scopeAnswers } : acc;
    }, {});

    return {
      ...customCo2Answers,
      answers: filteredAnswers,
    };
  };

  const getCarbonFilledAnswers = () => {
    const carbonAnswers = answers[CALC_MODELS.CARBON];
    if (!carbonAnswers) return null;
    const filledAnswers = Object.keys(carbonAnswers).reduce((acc, category) => {
      const categoryAnswers = Object.keys(carbonAnswers[category] || {}).reduce(
        (catAcc, question) => {
          const questionAnswers = carbonAnswers[category][question]?.filter(
            (activity) => activity.filled
          );
          if (questionAnswers?.length) {
            return { ...catAcc, [question]: questionAnswers };
          }
          return catAcc;
        },
        {}
      );
      if (Object.keys(categoryAnswers).length) {
        return { ...acc, [category]: categoryAnswers };
      }
      return acc;
    }, {});
    return {
      ...filledAnswers,
    };
  };

  const filters = {
    [CALC_MODELS.CUSTOM_CO2]: getCo2FilledAnswers,
    [CALC_MODELS.CARBON]: getCarbonFilledAnswers,
  };

  useEffect(() => {
    const modelsToSave = Object.keys(dirtyAnswersMap).filter((model) => dirtyAnswersMap[model]);
    if (modelsToSave.length === 0) return;

    const saveModels = async () => {
      try {
        await Promise.all(
          modelsToSave.map((modelName) => {
            const payload = {
              calculator_id: draftId,
              model: modelName,
              data: JSON.stringify(filters[modelName]()),
              state_graphics: JSON.stringify(chartData),
            };
            // Добавляем last_position только если pathname не содержит 'answer'
            if (!pathname.includes('answers')) {
              payload.last_position = pathname;
            }
            return updateCalcAnswer(payload);
          })
        );
      } catch (e) {
        console.error('Error saving models:', e);
      } finally {
        setDirtyAnswersMap({
          ...modelsToSave.reduce((acc, modelName) => {
            acc[modelName] = false;
            return acc;
          }, {}),
        });
      }
    };

    saveModels();
  }, [dirtyAnswersMap]);
};
